import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InventoryItemsTableSkeleton = () => (
  <Styles.TableRows>
    <Skeleton variant="rounded" width="100%" height={40} />
    {Array.from({ length: 10 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" width="100%" height={56} />
    ))}
  </Styles.TableRows>
)

export default InventoryItemsTableSkeleton
